module.exports = __webpack_public_path__ + "static/media/maintenance2.04e5d0d7.svg";